export default "__VITE_ASSET__mAmhSwZM__"